import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DropdownOption } from '@maced/angular-components/lib/dropdown/dropdown.model';
import { Tree } from '@maced/angular-components/lib/tree/tree.interface';
import { Subscription } from 'rxjs';
import { NodeStatus } from './tree.enum';

@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html'
})
export class TreeComponent implements OnInit, OnDestroy {
  treeItemList: Tree[] = [
    {
      id: '1',
      customField: 'true',
      label: 'Unit 1 ME',
      hasCheckbox: true,
      checked: false,
      arrowChecked: false,
      children: [
        {
          id: '2',
          customField: 'true',
          label: 'Lesson 1',
          hasCheckbox: true,
          checked: false,
          arrowChecked: false,
          children: [
            {
              id: '3',
              customField: 'true',
              label: 'Section 1',
              hasCheckbox: true,
              checked: false,
              arrowChecked: false,
              children: [
                {
                  id: '31',
                  customField: 'true',
                  label: 'Sub-Section Level One',
                  hasCheckbox: true,
                  checked: false,
                  arrowChecked: false,
                  children: [
                    {
                      id: '311',
                      customField: 'true',
                      label: 'Sub-Section Level Two',
                      hasCheckbox: true,
                      checked: false,
                      arrowChecked: false,
                      children: [
                        {
                          id: '3111',
                          customField: 'true',
                          label: 'Sub-Section Level Three',
                          hasCheckbox: true,
                          checked: false,
                          arrowChecked: false
                        }]
                    }]
                }]
            },
            {
              id: '4',
              customField: 'true',
              label: 'Section 2',
              hasCheckbox: true,
              checked: false,
              arrowChecked: false,
              children: [
                {
                  id: '41',
                  customField: 'true',
                  label: 'Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetur consectetur Lorem ipsum dolor sit amet, consectetur',
                  hasCheckbox: true,
                  checked: false,
                  arrowChecked: false,
                  children: [
                    {
                      id: '411',
                      customField: 'true',
                      label: 'Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetur',
                      hasCheckbox: true,
                      checked: false,
                      arrowChecked: false,
                    }]
                }]
            },
          ]
        },
        {
          id: '5',
          customField: 'true',
          label: 'Lesson 2',
          hasCheckbox: true,
          checked: false,
          arrowChecked: false,
          children: [
            {
              id: '6',
              customField: 'true',
              label: 'Section 1',
              hasCheckbox: true,
              checked: false,
              children:[],
              arrowChecked: false
            },
            {
              id: '7',
              customField: 'true',
              label: 'Section 2',
              hasCheckbox: true,
              checked: false,
              arrowChecked: false,
            }
          ]
        },
        {
          id: '8',
          customField: 'true',
          label: 'Lesson 3',
          hasCheckbox: true,
          checked: false,
          arrowChecked: false,
          children: [
            {
              id: 9,
              customField: 'true',
              label: 'Section 1',
              hasCheckbox: true,
              checked: false,
              arrowChecked: false
            },
            {
              id: 10,
              customField: 'true',
              label: 'Section 2',
              hasCheckbox: true,
              checked: false,
              children:[],
              arrowChecked: false
            }
          ]
        },
        {
          id: 11,
          customField: 'true',
          label: 'Lesson 4',
          hasCheckbox: true,
          checked: false,
          arrowChecked: false,
          children: [
            {
              id: 12,
              customField: 'true',
              label: 'Section 1',
              hasCheckbox: true,
              checked: false,
              arrowChecked: false
            },
            {
              id: 13,
              customField: 'true',
              label: 'Section 2',
              hasCheckbox: true,
              checked: false,
              arrowChecked: false
            }
          ]
        }
      ]
    },
    {
      id: 14,
      customField: 'true',
      label: 'Unit 2 My place',
      hasCheckbox: false,
      checked: false,
      arrowChecked: false,
      children: [
        {
          id: 15,
          customField: 'true',
          label: 'Lesson 1',
          hasCheckbox: true,
          checked: false,
          arrowChecked: false,
          children: [
            {
              id: 16,
              customField: 'true',
              label: 'Section 1',
              hasCheckbox: true,
              checked: false,
              arrowChecked: false
            },
            {
              id: 17,
              customField: 'true',
              label: 'Section 2',
              hasCheckbox: true,
              checked: false,
              arrowChecked: false
            }
          ]
        },
        {
          id: 18,
          customField: 'true',
          label: 'Lesson 2',
          hasCheckbox: true,
          checked: false,
          arrowChecked: false,
          children: [
            {
              id: 19,
              customField: 'true',
              label: 'Section 1',
              hasCheckbox: true,
              checked: false,
              arrowChecked: false
            },
            {
              id: 20,
              customField: 'true',
              label: 'Section 2',
              hasCheckbox: true,
              checked: false,
              arrowChecked: false
            }
          ]
        },
        {
          id: 21,
          customField: 'true',
          label: 'Lesson 3',
          hasCheckbox: true,
          checked: false,
          arrowChecked: false,
          children: [
            {
              id: 22,
              customField: 'true',
              label: 'Section 1',
              hasCheckbox: true,
              checked: false,
              arrowChecked: false
            },
            {
              id: 23,
              customField: 'true',
              label: 'Section 2',
              hasCheckbox: true,
              checked: false,
              arrowChecked: false
            }
          ]
        },
        {
          id: 24,
          customField: 'true',
          label: 'Lesson 4',
          hasCheckbox: true,
          checked: false,
          arrowChecked: false,
          children: [
            {
              id: 25,
              customField: 'true',
              label: 'Section 1',
              hasCheckbox: true,
              checked: false,
              arrowChecked: false
            },
            {
              id: 26,
              customField: 'true',
              label: 'Section 2',
              hasCheckbox: true,
              checked: false,
              arrowChecked: false
            }
          ]
        }
      ]
    }
  ];
  optionList = ['SingleNodeSelection', 'ParentChildSelection','ParentToChild&SingleNodeSelection'];
  option = 'SingleNodeSelection';
  isBrowser = true;
  itemList: Tree[] = [];
  currentUrl: string;
  routeSubscription: Subscription | undefined;
  queryParamSubscription: Subscription | undefined;
  selectedOptions!: DropdownOption;

  constructor(
    @Inject(PLATFORM_ID) public platformId: Object,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.currentUrl = this.router.url.split('?')[0];
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    } else {
      this.isBrowser = false;
    }
  }

  ngOnInit(): void {
    this.routeSubscription = this.activatedRoute.queryParams.subscribe(res => {
      if (res['clearCheckbox'] || res['tree2']) {
        this.unCheckAllCheckboxes();
      } else if (res['tree4']) {
        let paramNodeIds = res['tree4']
        this.treeItemList.forEach((nodeObj) => {
          if (paramNodeIds.includes(nodeObj.id + '')) {
            nodeObj.checked = true;
          }
          if (nodeObj.children) {
            this.updateTreenode(nodeObj, paramNodeIds);
          }
        });
      }
    });
  }

  updateTreenode(nodeObj: any, paramNodeIds: any) {
    if (nodeObj.children) {
      nodeObj.children.forEach((childerObj: Tree) => {
        if (paramNodeIds.includes(childerObj.id + '')) {
          childerObj.checked = true;
        }
        this.updateTreenode(childerObj, paramNodeIds);
      })
    }
  }

  treeEvent(event: any) {
    this.itemList = event;
  }

  unCheckAllCheckboxes(): void {
    const qParams: Params = {};
    this.router.navigate([this.currentUrl], {
      relativeTo: this.activatedRoute,
      queryParams: qParams
    });
    this.clearAllCheckbox();
  }

  clearAllCheckbox(): void {
    this.itemList.forEach((obj: Tree) => {
      obj.checked = false;
      obj.status = NodeStatus.unchecked;
      if (obj.children) {
        this.unCheckAllChildrens(obj);
      }
    });
  }

  unCheckAllChildrens(obj: Tree): void {
    obj.checked = false;
    obj.status = NodeStatus.unchecked;
    if (obj.children) {
      obj.children.forEach((childObj: Tree) => {
        childObj.checked = false;
        obj.status = NodeStatus.unchecked;
        this.unCheckAllChildrens(childObj);
      });
    }
  }

  ngOnDestroy(): void {
    if (this.routeSubscription && this.queryParamSubscription) {
      this.routeSubscription.unsubscribe();
      this.queryParamSubscription.unsubscribe();
    }
  }
}